import React, {Component} from 'react';
import {ClipLoader} from "react-spinners";

import "./index.css"

class Spinner extends Component {
    render(){
        return(
            <div className="text-center spinner">
                <ClipLoader
            sizeUnit={"px"}
            size={75}
            color={'#000000'}
            />    
        </div>
        )    
    }
}

export default Spinner


// WEBPACK FOOTER //
// ./src/components/Spinner/index.js